import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import NotificationService from "../../services/Notification";
import { DateTime } from "luxon";

export const UsersModal = ({ isOpen, onClose, id, func }: any) => {
  function getFormattedDateTime() {
    const now = DateTime.local();
    const formattedDate = now.toFormat("MM/dd/yyyy");

    const formattedTime = now.toFormat("hh:mm a");

    return {
      date: formattedDate,
      time: formattedTime,
    };
  }
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const fetchUsers = () => {
    NotificationService.getAllUsers().then((res) => {
      // console.log(res.data);
      setUsers(res.data);
    });
  };
  const handleSubmit = () => {
    if (selectedUsers.length > 0) {
      const tokens = selectedUsers.map((el: any) => el.value);
      const ids = selectedUsers.map((el: any) => el.uuid);
      const data = {
        notification_id: id,
        application_type: "USER",
        lead_ids: ids,
        notification_status: "PENDING",
        source: "MANUAL",
        schedule_date: getFormattedDateTime().date,
        schedule_time: getFormattedDateTime().time,
        variable_values: [],
        error: [],
        target: "",
      };
      NotificationService.createNotifcationEvent(data);
    }
    func();
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  return (
    <Modal isOpen={isOpen} onClose={func}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Users</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <MultiSelect
            options={users}
            labelledBy="Select Users"
            value={selectedUsers}
            onChange={setSelectedUsers}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Send
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={func}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
